import React from "react";
import Item from "../Item";
import Title from "./Title";
import { Avatar, Collapse, Popover } from "antd";

import { ICON } from "../../GuidelineSelect/GuidelineCheckbox";

import type { CollapseProps } from "antd";
import type { TypeTitleProps } from "./Title";

interface TypeContactRelationProps {
  lenderIds: string[];
  LENDER_CONTACT: Record<string, TypeTitleProps>;
}

/**
 * @name ContactRelation 对话内容中展示的关联关系
 */
const ContactRelation: React.FC<TypeContactRelationProps> = ({
  lenderIds,
  LENDER_CONTACT,
}) => {
  const LENDERS = lenderIds
    .filter((k) => LENDER_CONTACT?.[k]?.contacts)
    .map((k) => LENDER_CONTACT[k]);

  const items: CollapseProps["items"] = LENDERS.map((v) => ({
    key: v.lenderId,
    label: <Title {...v} />,
    children: v?.contacts?.map((v) => <Item {...v} key={v.id} />),
  }));

  if (!LENDERS?.length) return null;

  const PLURAL = items?.length > 1 ? "s" : "";

  return (
    <Popover
      arrow={false}
      placement="topLeft"
      rootClassName="scenario-contact-relation-ctx"
      content={
        <>
          <div className="scenario-contact-relation-header">
            <span>Contact Lender{PLURAL}</span>
            <span>
              <span>
                {items?.length || 0} lender{PLURAL}
              </span>
              {/* <CloseOutlined rev={undefined} /> */}
            </span>
          </div>

          <div className="scenario-contact-relation-list">
            <div className="scenario-contact-relation-collapse">
              <Collapse items={items} />
            </div>
          </div>
        </>
      }
    >
      <div className="scenario-contact-relation">
        <Avatar.Group size="small">
          {LENDERS.splice(0, 4).map((v) => (
            <Avatar key={v.lenderId} src={ICON[v.lenderDisplayName]} />
          ))}
        </Avatar.Group>
        <span>Contact lender{PLURAL}</span>
      </div>
    </Popover>
  );
};

export default ContactRelation;
